import borrowImg from '../Img/Borrowing_Img.png'
import lendingImg from '../Img/Lending_Img.png'
const HomeMainSection = () => {
    return (
        <>
            <div className="home-main-section-first-text">
                <h2 className="first-text animate__animated animate__tada">Unlock Your Financial Freedom</h2>
            </div>
            <div className="home-main-section-smco">
                <img src={lendingImg} alt="Lending" className="lending-image" />
                <img src={borrowImg} alt="Borrowing" className="borrowing-image" />
            </div>
        </>
    );
};

export default HomeMainSection;